
import { loadMessages, locale } from 'devextreme/localization';
import { dxCommonMessages } from './components/dx-common.i18n';
import { dxFileUploaderMessages } from './components/dx-file-uploader.i18n';
import { dxHtmlEditorMessages } from './components/dx-html-editor.i18n';
import { defaultLanguage } from '@shared/utils/language-loader';

export const devExtremeMessages = {
  'pt-BR': {
    ...dxCommonMessages['pt-BR'],
    ...dxHtmlEditorMessages['pt-BR'],
    ...dxFileUploaderMessages['pt-BR']
  },
  'en-US': {
    ...dxCommonMessages['en-US'],
    ...dxHtmlEditorMessages['en-US'],
    ...dxFileUploaderMessages['en-US']
  },
  'es-ES': {
    ...dxCommonMessages['es-ES'],
    ...dxHtmlEditorMessages['es-ES'],
    ...dxFileUploaderMessages['es-ES']
  }
};

/**
 * Applies the DevExtreme locale. Called with no argument at bootstrap, before
 * the `LanguageStore` has resolved anything — that is not a misconfiguration,
 * so only an explicitly unsupported language warns.
 */
export function configureDevExtremeLocalization(language?: string): void {
  loadMessages(devExtremeMessages);
  if (language && devExtremeMessages[language]) {
    locale(language);
    return;
  }
  if (language) {
    console.warn(`Language '${language}' not supported. Using '${defaultLanguage}' as default.`);
  }
  locale(defaultLanguage);
}
